import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import PdfTypeService from "../../services/pdf/PdfTypeService";
import { loadingPdfTypeDropdown } from "../../store/slices/pdf/pdfTypeSlice";

export const usePdfType = () => {
  const dispatch: AppDispatch = useDispatch();

  const { pdfTypeDropdown } = useSelector(
    (state: RootState) => state.pdfType
  );

  const fetchPdfTypeDropdown = async () => {
    try {
      const response = await PdfTypeService.fetchDropdown();
      // console.log(response);
      dispatch(loadingPdfTypeDropdown(response));
    } catch (error) {
      console.error("Error al cargar pdf types:", error);
    }
  };

  return {
    pdfTypeDropdown,
    fetchPdfTypeDropdown,
  };
};
